import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/c3b_file.svg
 */
const IconC3BFile: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M21.75 5.69L16.81.75A2.805 2.805 0 0015 0H6.75A2.253 2.253 0 004.5 2.25v7.5a.75.75 0 001.5 0v-7.5a.75.75 0 01.75-.75h6.75A1.5 1.5 0 0115 3v2.813A1.693 1.693 0 0016.687 7.5h2.812A1.5 1.5 0 0121 9v12.75a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75.75.75 0 00-1.5 0A2.253 2.253 0 006.75 24h13.5a2.253 2.253 0 002.25-2.25V7.5a2.808 2.808 0 00-.75-1.81z"
      fill="currentColor"
    />
    <path
      d="M13.431 17.203v-1.542h.942c.56 0 .841.258.841.774 0 .24-.076.428-.23.565-.15.136-.357.203-.62.203h-.933zM14.284 15.208h-.853v-1.363h.836c.28 0 .49.054.627.162.137.106.206.277.206.512a.62.62 0 01-.224.504c-.147.123-.344.185-.592.185z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.201 11.25H18.8a.7.7 0 01.701.7v7.6a.7.7 0 01-.7.7H2.2a.7.7 0 01-.7-.7v-7.6a.7.7 0 01.7-.7zm6.506 5.056c-.053.453-.22.803-.503 1.05-.28.246-.654.368-1.121.368-.506 0-.912-.181-1.218-.544-.305-.363-.457-.849-.457-1.457v-.412c0-.398.071-.748.212-1.05.144-.303.346-.534.607-.695.26-.163.563-.245.906-.245.455 0 .82.128 1.095.383.274.253.434.604.48 1.054h-.569c-.049-.342-.155-.589-.32-.742-.163-.153-.392-.23-.686-.23-.361 0-.645.134-.85.4-.205.268-.307.647-.307 1.14v.415c0 .465.098.835.292 1.11a.942.942 0 00.815.411c.314 0 .554-.07.721-.212.169-.143.28-.391.335-.744h.568zm1.425-1.048h.409c.257-.004.46-.072.606-.203a.678.678 0 00.22-.533c0-.502-.25-.753-.75-.753-.235 0-.423.067-.565.203a.703.703 0 00-.209.533H9.3c0-.34.124-.621.37-.845.25-.226.566-.338.948-.338.405 0 .721.106.951.32.23.214.344.511.344.892 0 .186-.06.367-.182.541-.12.175-.284.306-.492.392.236.074.417.198.545.37.13.173.194.384.194.634 0 .384-.125.69-.377.915-.25.225-.577.338-.98.338-.402 0-.73-.109-.983-.326-.25-.218-.376-.506-.376-.863h.547a.7.7 0 00.22.542c.148.135.345.203.592.203.263 0 .464-.069.604-.206.139-.138.209-.335.209-.592 0-.249-.077-.44-.23-.574-.153-.133-.374-.202-.662-.206h-.41v-.444zm2.734-1.878v4.285h1.486c.455 0 .807-.11 1.057-.33.249-.219.373-.521.373-.906 0-.25-.067-.467-.203-.647a.984.984 0 00-.547-.371 1.11 1.11 0 00.465-.356.877.877 0 00.17-.533c0-.377-.117-.66-.352-.853-.234-.193-.583-.289-1.048-.289h-1.401z"
      fill="currentColor"
    />
  </svg>
);

export default IconC3BFile;
